var map = {
	"./aboutUs.webp": 4238,
	"./bg1.webp": 3757,
	"./bg2.webp": 928,
	"./contactImg.webp": 9402,
	"./headerBg.webp": 335,
	"./homePerson.webp": 9535,
	"./logo.webp": 1930,
	"./reasonIcon1.webp": 9427,
	"./reasonIcon2.webp": 2002,
	"./reasonIcon3.webp": 5021,
	"./reasonIcon4.webp": 5804,
	"./serviceIcon1.webp": 9904,
	"./serviceIcon2.webp": 4157,
	"./serviceIcon3.webp": 1394,
	"./serviceIcon4.webp": 175,
	"./serviceImg.webp": 5607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;